import { put, call, all, takeEvery, select } from 'redux-saga/effects';
import {
  toggleFeedbackPage,
  openNotificationsDropdown,
  toggleDamzPage,
} from './actions';
import { PageViewBiEvent, PureBiData } from '@wix/da-bi/pkg/events';
import {
  exitDuperbrowse,
  openDuperbrowse,
} from '../../Duperbrowse/redux/actionCreators';
import {
  DAMZ_PAGE_DUPERBROWSE_ITEMID,
  DAMZ_PAGE_DUPERBROWSE_STREAMID,
  FEEDBACK_PAGE_DUPERBROWSE_ITEMID,
  FEEDBACK_PAGE_DUPERBROWSE_STREAMID,
} from '../../Duperbrowse/redux/constants';
import { DuperbrowseSimpleStream } from '../../Duperbrowse/redux/types';
import { getIsDamzPageOpen, getIsFeedbackPageOpen } from './selectors';
import { logBiEvent } from '../../biLogger/redux/saga';

function* handleOpenNotificationDropdown() {
  // not using logPageView here because this is a fake pageview event and we
  // should avoid the side effects running
  yield call(
    logBiEvent,
    PureBiData<PageViewBiEvent>({
      evid: 99,
      view: 'notifications',
      component: 'header',
    })
  );
}

function* handleToggleFeedbackPage() {
  const isOpen = yield select(getIsFeedbackPageOpen);
  if (isOpen) {
    yield put(exitDuperbrowse());
  } else {
    yield put(
      openDuperbrowse(FEEDBACK_PAGE_DUPERBROWSE_ITEMID, {
        streamId: FEEDBACK_PAGE_DUPERBROWSE_STREAMID,
        items: [FEEDBACK_PAGE_DUPERBROWSE_ITEMID],
      } as DuperbrowseSimpleStream)
    );
  }
}

function* handleToggleDamzPage() {
  const isOpen = yield select(getIsDamzPageOpen);
  if (isOpen) {
    yield put(exitDuperbrowse());
  } else {
    yield put(
      openDuperbrowse(DAMZ_PAGE_DUPERBROWSE_ITEMID, {
        streamId: DAMZ_PAGE_DUPERBROWSE_STREAMID,
        items: [DAMZ_PAGE_DUPERBROWSE_ITEMID],
      } as DuperbrowseSimpleStream)
    );
  }
}

export default function* saga(): any {
  yield all([
    takeEvery(openNotificationsDropdown, handleOpenNotificationDropdown),
    takeEvery(toggleFeedbackPage, handleToggleFeedbackPage),
    takeEvery(toggleDamzPage, handleToggleDamzPage),
  ]);
}
